// extracted by mini-css-extract-plugin
export default {"btnpwd":"_13d1fa6c98"};